import { FlexBox, SPACING, Typography } from "@joonapp/web-shared"
import { Trans, useTranslation } from "react-i18next"
import { create } from "zustand"

import SlideUpModal from "../../../components/slideUpModal/SlideUpModal"

interface QuestGroupInfoModalStoreProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useQuestGroupInfoModalStore =
  create<QuestGroupInfoModalStoreProps>()((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  }))

export const QuestGroupInfoModal = () => {
  const { isOpen, onClose } = useQuestGroupInfoModalStore()
  const { t } = useTranslation()

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
      zIndex={1000}
    >
      <FlexBox
        direction="column"
        gap={SPACING.space2}
        wrap={false}
        style={{
          padding: `${SPACING.space8} ${SPACING.space4} ${SPACING.space14} ${SPACING.space4}`,
        }}
        fullWidth
      >
        <Typography variant="bodyBold">
          {t("QUEST_GROUP_INFO_TITLE")}
        </Typography>
        <Typography variant="bodySmall">
          <Trans
            i18nKey="QUEST_GROUP_INFO_P1"
            components={{
              b: (
                <Typography
                  variant="bodySmallBold"
                  style={{ lineHeight: "1.25rem" }}
                >
                  {""}
                </Typography>
              ),
            }}
          />
        </Typography>
        <FlexBox direction="column">
          <Typography
            variant="bodySmall"
            style={{ textDecoration: "underline", whiteSpace: "pre-line" }}
          >
            {t("QUEST_GROUP_SAMPLE_GROUPED")}
          </Typography>
          <ul style={{ listStyleType: "disc", marginTop: 0 }}>
            <li>
              <Typography variant="bodySmall">
                {t("QUEST_GROUP_EX1")}
              </Typography>
            </li>
            <li>
              <Typography variant="bodySmall">
                {t("QUEST_GROUP_EX2")}
              </Typography>
            </li>
          </ul>
        </FlexBox>
        <Typography variant="bodySmall">
          <Trans
            i18nKey="QUEST_GROUP_INFO_P2"
            components={{
              b: (
                <Typography
                  variant="bodySmallBold"
                  style={{ lineHeight: "1.25rem" }}
                >
                  {""}
                </Typography>
              ),
            }}
          />
        </Typography>
        <FlexBox direction="column">
          <Typography
            variant="bodySmall"
            style={{ textDecoration: "underline" }}
          >
            {t("QUEST_GROUP_SAMPLE_UNGROUPED")}
          </Typography>
          <ul style={{ listStyleType: "disc", marginTop: 0 }}>
            <li>
              <FlexBox direction="column">
                <Typography
                  variant="bodySmallBold"
                  style={{ lineHeight: "1.25rem" }}
                >
                  {t("QUEST_GROUP_EX3")}
                </Typography>
                <Typography variant="bodySmall">
                  <Trans
                    i18nKey="QUEST_GROUP_INFO_P3"
                    components={{
                      b: <Typography variant="bodySmallBold">{""}</Typography>,
                    }}
                  />
                </Typography>
                <ul style={{ listStyleType: "disc", marginTop: 0 }}>
                  <li>
                    <Typography variant="bodySmall">
                      {t("QUEST_GROUP_EX4")}
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="bodySmall">
                      {t("QUEST_GROUP_EX5")}
                    </Typography>
                  </li>
                </ul>
              </FlexBox>
            </li>
          </ul>
        </FlexBox>
      </FlexBox>
    </SlideUpModal>
  )
}
